import { RootStackRoutes } from 'types';
import { FeatureModule } from '../earn';
import { AccountManagementNavigator, AccountManagementStackRoutes } from './account.navigator';
import en from './i18n/en.json';
import zhCn from './i18n/zh-CN.json';
import zhHk from './i18n/zh-HK.json';
import jaJp from './i18n/ja-JP.json';

const AccountManagementApp: FeatureModule = {
  name: RootStackRoutes.AccountManagement,
  version: '1.0.0',
  hooks: {},
  screens: {
    main: AccountManagementNavigator
  },
  routes: {
    [AccountManagementStackRoutes.List]: {
      path: 'account-management'
    },
    [AccountManagementStackRoutes.Details]: {
      path: 'details'
    }
  },
  i18n: {
    en: en as Record<string, any>,
    'zh-HK': zhHk as Record<string, any>,
    'zh-CN': zhCn as Record<string, any>,
    'ja-JP': jaJp as Record<string, any>
  }
};

export default AccountManagementApp;
